import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-box',
  templateUrl: './loading-box.component.html',
  styleUrls: ['./loading-box.component.scss'],
})
export class LoadingBoxComponent implements OnInit, OnDestroy {

  interval: any;
  progressValue = 0;

  ngOnInit() {
    this.interval = setInterval(() => {
      this.progressValue += 10;
      if (this.progressValue >= 100) {
        clearInterval(this.interval);
      }
    }, 200);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
